import { imageNames } from "@/src/constants/imageConstants.js";

export const dataEnrichTableHeaders = [
  {
    label: "Enrichment Name",
    key: "name",
    width: 300,
  },
  { label: "Type", key: "type", width: 160 },
  { label: "Size", key: "size", width: 110 },
  {
    label: "Enriched By",
    key: "created_by_id",
    width: 200,
    view: true,
  },
  { label: "Enriched On", key: "enriched_on", width: 200 },
  { label: "", key: "actions", width: 160 },
];

export const selectorOptions = [
  {
    id: "people",
    title: "Enrich People",
    description: "Select a CSV of people and enrich their info",
    icon: imageNames.CONTACTS_GREY,
  },
  {
    id: "company",
    title: "Enrich Companies",
    description: "Select a CSV of companies and enrich their info",
    icon: imageNames.COMPANIES_GREY,
  },
];

export const PEOPLE_PROPERTIES = [
  { label: "First Name", value: "first_name" },
  { label: "Last Name", value: "last_name" },
  { label: "Title", value: "title" },
  { label: "LinkedIn", value: "linkedin_url" },
  { label: "City", value: "city" },
  { label: "State", value: "state" },
  { label: "Country", value: "country" },
  { label: "Company Name", value: "company_name" },
  { label: "Company Phone Number", value: "company_phone" },
  { label: "Emails", value: "emails" },
  { label: "Phone Numbers", value: "phone_numbers" },
];

export const COMPANY_PROPERTIES = [
  { label: "Company Name", value: "name" },
  { label: "Website", value: "website_url" },
  { label: "Industry", value: "industry" },
  { label: "Employee Size", value: "estimated_num_employees" },
  { label: "Annual Revenue", value: "annual_revenue" },
  { label: "Phone Number", value: "phone" },
  { label: "Company Linkedin URL", value: "linkedin_url" },
  { label: "Company Street", value: "street" },
  { label: "Company City", value: "city" },
  { label: "Company Postal Code", value: "postal_code" },
  { label: "Company State", value: "state" },
  { label: "Company Country", value: "country" },
];

export const SUPERSALES_PROPERTIES = {
  people: [
    { label: "First Name", value: "first_name", apiKey: "first_name" },
    { label: "Last Name", value: "last_name", apiKey: "last_name" },
    { label: "Email", value: "email", apiKey: "email" },
    { label: "Company Name", value: "company_name", apiKey: "company_name" },
    {
      label: "Company Domain",
      value: "company_domain",
      apiKey: "company_domain",
    },
    { label: "LinkedIn URL", value: "linkedin_url", apiKey: "linkedin_url" },
  ],
  company: [
    { label: "Name", value: "name", apiKey: "name" },
    { label: "Domain", value: "domain", apiKey: "domain" },
    { label: "LinkedIn URL", value: "linkedin_url", apiKey: "linkedin_url" },
  ],
};

export const listCompanyHeaders = ["name"];
export const listPeopleHeaders = ["name", "email", "current_company"];

export const STAGES = {
  TYPE_SELECTION: {
    step: 1,
    title: "Choose an upload type",
    subtitle: "Step 1 of 3",
    buttonText: "Upload CSV",
  },
  PROPERTY_SELECTION: {
    step: 2,
    title: "Choose properties to enrich",
    subtitle: "Step 2 of 3",
    buttonText: "Continue",
  },
  COLUMN_MAPPING: {
    step: 3,
    title: "Map properties to CSV columns",
    subtitle: "Step 3 of 3",
    buttonText: "Enrich CSV",
  },
};

export const LISTSTAGES = {
  TYPE_SELECTION: {
    step: 1,
    title: "Choose list object type",
    subtitle: "Step 1 of 3",
    buttonText: "Continue",
  },
  PROPERTY_SELECTION: {
    step: 2,
    title: "Choose properties to enrich",
    subtitle: "Step 2 of 3",
    buttonText: "Continue",
  },
  COLUMN_MAPPING: {
    step: 3,
    title: "Map properties to List",
    subtitle: "Step 3 of 3",
    buttonText: "Enrich List",
  },
};

export const WATERFALL_ENRICHMENT_SECTIONS = [
  {
    id: "email",
    title: "Email Enrichment",
    description:
      "Configure the order and accounts for email enrichment vendors",
    category: "email",
  },
  {
    id: "phone",
    title: "Phone Number Enrichment",
    description:
      "Configure the order and accounts for phone number enrichment vendors",
    category: "phone",
  },
];
